import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const SendNotifications = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default SendNotifications;
